module.exports = __webpack_public_path__ + "img/shots_on_target.1c6041e.png";